import serverAction from "~/serverAction"
import {
  IDataTagAssignmentsResponse,
  IDataTaggablesResponse,
  IDataTagsResponse, IResponse,
  IServerData
} from "~/interfaces/serverInterfaces"
import { HTTPMethod } from "~/providers/new/httpMethod"
import { StringHelper } from '~/helpers/stringHelper'
import { RouteHelper } from '~/helpers/routeHelper'
import { Route } from '~/enums/route'
import { ModelType } from '~/enums/modelType'
import { IDataTaggableResource } from '~/interfaces/dataTagInterfaces'

const BASE_ENDPOINT: string = Object.freeze("apps/:appId/data_taggables")

function buildEndpoint(params: Record<string, string>): string {
  return StringHelper.interpolate(BASE_ENDPOINT, params)
}

export const DataTaggableProvider = {
  fetch(appId: string): Promise<IServerData<IDataTaggablesResponse>> {
    return serverAction<IDataTaggablesResponse>({
      endpoint: buildEndpoint({ appId }),
      method: HTTPMethod.GET,
    })
  },
  fields(appId: string, taggable: { id: string, type: ModelType }) {
    return serverAction<{ published_data_taggable: IDataTaggableResource, }>({
      endpoint: RouteHelper.path({
        route: Route.appDataTagTaggableFields,
        modelOrId: taggable.id,
        namedWildcardOptions: [{ wildcard: ':appId', modelOrId: appId }],
        query: {
          type: ModelType[taggable.type],
        },
      }),
    })
  },
  fetchTaggedFieldInfo(
    appId: string,
    dataTaggable: { id: string, type: ModelType },
    query: Partial<{ viewId: string }>,
  ) {
    return serverAction<
      IResponse &
      Pick<IDataTagsResponse, 'data_tags'> &
      Pick<IDataTagAssignmentsResponse, 'data_tag_assignments'>
    >({
      endpoint: RouteHelper.path({
        route: Route.appDataTagTaggableTaggedFieldInfo,
        modelOrId: dataTaggable.id,
        namedWildcardOptions: [{wildcard: ':appId', modelOrId: appId}],
        query: {
          ...(query || {}),
          type: dataTaggable.type,
        },
      }),
      method: HTTPMethod.GET,
    });
  }
}
